import { useEffect, useRef } from 'react';
import { useCompany } from '@/company/context';
import { useWorkspace } from '../context';
import { libraryUploadScope, libraryUploads } from './upload-queue';

/**
 * The Library's uploads outlive its page (they go on while the person is elsewhere), so their wiring runs in the
 * workspace shell, which stays mounted on every page and in Settings:
 * - they belong to this person in this company: another one cancels and clears them;
 * - once a batch has settled, the rest of the workspace (pickers, Search) reads the new files;
 * - just-saved rows stay where they landed until the person leaves the Library. That follows the view, not the page
 *   mounting: a workspace refresh can show the loading state over the Library for a moment.
 */
export function useLibraryUploadWiring() {
  const ws = useWorkspace();
  const company = useCompany();
  const scope = libraryUploadScope(company.data?.company?.id, ws.user?.id);
  useEffect(() => libraryUploads.setScope(scope), [scope]);
  const refresh = useRef(ws.refresh);
  refresh.current = ws.refresh;
  useEffect(() => libraryUploads.onSettled(() => void refresh.current()), []);
  const inLibrary = ws.view === 'results' || ws.view === 'files';
  useEffect(() => {
    if (!inLibrary) libraryUploads.forgetFinished();
  }, [inLibrary]);
}
